import React from 'react';
import { Button } from '../ui/Button';
import { FadeIn } from '../ui/FadeIn';
export function Hero() {
  return <section className="pt-28 pb-12 md:pt-36 md:pb-16 overflow-hidden" data-id="element-86">
      <div className="max-w-4xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-87">
        <FadeIn data-id="element-88">
          <h1 className="font-serif font-semibold text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-brand-ink mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-89">
            Deja de vivir desconectada de ti y vuelve a tu esencia
          </h1>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-90">
          <p className="font-serif italic text-xl md:text-2xl lg:text-3xl text-brand-eucalyptus mb-10 md:mb-12" data-id="element-91">
            Pasé años aprendiendo a obedecer. Hoy elijo escucharme.
          </p>
        </FadeIn>

        <FadeIn delay={0.15} direction="none" className="w-full" data-id="element-92">
          <div className="relative w-full max-w-sm mx-auto aspect-[4/5] rounded-[2rem] overflow-hidden bg-brand-sage-light/30 mb-10 md:mb-12" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/4w3YegEoagJX3fCANm7tzM/image.png" alt="Helen Gerberg" className="w-full h-full object-cover object-center" data-id="element-94" />
            <div className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-brand-ink/5 pointer-events-none" data-id="element-95"></div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-96">
          <p className="font-sans text-xl md:text-2xl lg:text-3xl text-brand-eucalyptus font-semibold mb-6 max-w-2xl mx-auto leading-snug" data-id="element-97">
            Devela tu verdadero ser: vuelve a ti más allá de tus heridas y
            condicionamientos.
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-98">
          <p className="font-sans text-lg md:text-xl text-brand-ink/80 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-99">
            Mira esta masterclass gratuita y descubre por qué te sientes lejos
            de ti, cómo tu energía intenta guiarte y qué puedes hacer para
            reconectar contigo desde un lugar más claro, amoroso y auténtico.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-100">
          <Button href="#masterclass" variant="primary" className="w-full sm:w-auto" data-id="element-101">
            Ver masterclass gratuita
          </Button>
          <Button href="https://api.leadconnectorhq.com/widget/booking/kiMwaUwzHpX0z6UxKbPj" variant="secondary" className="w-full sm:w-auto" data-id="element-102">
            Agendar llamada de descubrimiento
          </Button>
        </FadeIn>
      </div>
    </section>;
}